import React, { memo } from "react";

import type { SlateRenderElementProps } from "../slateTypes";

const Heading: React.FC<SlateRenderElementProps> = memo(props => {
  const depth = props.element.depth;
  switch (depth) {
    case 1:
      return (
        <h1 data-testid="heading1" {...props.attributes}>
          {props.children}
        </h1>
      );
    case 2:
      return (
        <h2 data-testid="heading2" {...props.attributes}>
          {props.children}
        </h2>
      );
    case 3:
      return (
        <h3 data-testid="heading3" {...props.attributes}>
          {props.children}
        </h3>
      );
    case 4:
      return (
        <h4 data-testid="heading4" {...props.attributes}>
          {props.children}
        </h4>
      );
    case 5:
      return (
        <h5 data-testid="heading5" {...props.attributes}>
          {props.children}
        </h5>
      );
    default:
      return (
        <h6 data-testid="heading6" {...props.attributes}>
          {props.children}
        </h6>
      );
  }
});

export { Heading };
